import { z } from "zod";

import { MaterialGradeSchema } from "./PrismaZod";

export const MaterialPriceAlertSchema = z.object({
  row: z.number(),
  length: z.number(),
  width: z.number(),
  price: z.number(),
  minPrice: z.number(),
  materialGrade: MaterialGradeSchema,
});

export type MaterialPriceAlert = z.infer<typeof MaterialPriceAlertSchema>;
